export const AddyComplete = window.AddyComplete;
export const L = window.L;
export const $ = window.$;
// Addy
export const ADDY_API_KEY = '935705f34ef141f0a6397cfb05a5392e';
// Leaflet
export const greenIcon = L.icon({
    iconUrl: '/marker.svg',
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowUrl: 'https://unpkg.com/leaflet@1.5.1/dist/images/marker-shadow.png',
    shadowSize: [41, 41],
    shadowAnchor: [12, 41]
});
